import { render, staticRenderFns } from "./videoplayFree.vue?vue&type=template&id=872fc596&scoped=true&"
import script from "./videoplayFree.vue?vue&type=script&lang=js&"
export * from "./videoplayFree.vue?vue&type=script&lang=js&"
import style0 from "./videoplayFree.vue?vue&type=style&index=0&id=872fc596&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872fc596",
  null
  
)

export default component.exports